import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useEventManagementMaster } from "../../store/eventmanagement/reducer";
import { REQUEST_DELETE_MASTER_EVENTS } from "../../store/eventmanagement/eventsActionTypes";

interface EventsDeleteProps {
  event: any;
  isOpen: boolean;
  onClose: () => void;
}
const EventDeleteConfirmation: React.FC<EventsDeleteProps> = ({
  event,
  isOpen,
  onClose,
}) => {
  const dispatch = useDispatch();
  const {
    masterEventManagement: events,
    busy,
    message,
  } = useEventManagementMaster();

  const toast = useToast();

  useEffect(() => {
    const findEvent = events.find(
      (val: Record<string, any>) => val._id === event.key
    );
    if (!findEvent) {
      toast({
        title: "Success.",
        description: "event is deleted.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [event, events, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Event</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this event?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_EVENTS,
                payload: { _id: event.key },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default EventDeleteConfirmation;
